import React from 'react';
import Header from '../components/Header';
import TemporaryCardBlock from '../components/TemporaryCardBlock';
import UnblockCard from '../components/UnblockCard';


export default function CardBlock() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      <Header />
      <main>
        <TemporaryCardBlock />
      </main>
      
    </div>
  );
}